define(function(require) {
  // templates
  const tpl = require('civicsViews/code_violations/templates/t_itv_violation_item.hbs');
  return Marionette.ItemView.extend({
    initialize: function(options) {
      if (__DEV__) console.log('itv_violation_item -- initialized');
      this.config = options.config;
    },
    template: tpl,
    tagName: 'div',
    className: function() {
      return 'code-violation-item list-row';
    },
    attributes: {
      'role': 'row'
    },
    templateHelpers: function() {
      var self = this;
      var helpers = {
        showComments: function() {
          return !self.config.isPublic;
        },
      };
      return helpers;
    },
  });
});
